export default "__VITE_ASSET__DmDjmla8__"